// extracted by mini-css-extract-plugin
export var attachmentContainer = "_la-0";
export var fileList = "_la-2";
export var removeFileButton = "_la-1";